<template>
  <div>
    <div id="loading">
      <div class="spinner"></div>
    </div>
    <canvas id="canvas" width="100%" height="100%"></canvas>
    <div class="btn">
      <h1 class="logo">
        <div class="logo-mark">
          <img src="@/assets/logo_c.png" />
        </div>
        <div class="logo-text">
          <img src="@/assets/name.png" />
        </div>
      </h1>
      <div class="btn-box">
        <router-link to="/" tag="div" v-on:click.native="ground1" class="btn-text" id="home_click">Home</router-link>
        <router-link to="/about/" tag="div" v-on:click.native="ground2" class="btn-text" id="about_click">About</router-link>
        <router-link to="/contact/" tag="div" v-on:click.native="ground3" class="btn-text" id="contact_click">Contact</router-link>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */

import * as THREE from "three";
import { TweenMax } from "gsap";
const SimplexNoise = require("simplex-noise");

export default {
  name: "SnowThaw",
  data() {
    const scene = new THREE.Scene();
    scene.fog = new THREE.Fog(0xffffff, 3, 12);
    let rot;
    let radian;
    const renderer = null;
    const camera = new THREE.PerspectiveCamera(
      35,
      window.innerWidth / window.innerHeight,
      0.1,
      15
    );
    const light = new THREE.AmbientLight(0xffffff, 0.55);
    const light2 = new THREE.DirectionalLight(0xffffff, 1);
    const geometryC = new THREE.BoxGeometry(10, 10, 10);
    const loader = new THREE.TextureLoader();
    const materialC = [
      new THREE.MeshBasicMaterial({
        map: loader.load(require("@/assets/501_yw.right.jpg")),
        side: THREE.DoubleSide
      }),
      new THREE.MeshBasicMaterial({
        map: loader.load(require("@/assets/501_yw.left.jpg")),
        side: THREE.DoubleSide
      }),
      new THREE.MeshBasicMaterial({
        map: loader.load(require("@/assets/501_yw.top.jpg")),
        side: THREE.DoubleSide
      }),
      new THREE.MeshBasicMaterial({
        map: loader.load(require("@/assets/501_yw.bottom.jpg")),
        side: THREE.DoubleSide
      }),
      new THREE.MeshBasicMaterial({
        map: loader.load(require("@/assets/501_yw.front.jpg")),
        side: THREE.DoubleSide
      }),
      new THREE.MeshBasicMaterial({
        map: loader.load(require("@/assets/501_yw.back.jpg")),
        side: THREE.DoubleSide
      })
    ];
    const cube = new THREE.Mesh(geometryC, materialC);
    let i;
    const simplexNoise = new SimplexNoise();
    const geometryG = new THREE.PlaneGeometry(10, 10, 64, 64);
    const map1 = new THREE.TextureLoader().load(require("@/assets/map3_l.jpg"));
    const ground = new THREE.Mesh(
      geometryG,
      new THREE.MeshLambertMaterial({ map: map1 })
    );
    const crystal = new THREE.TextureLoader().load(
      require("@/assets/crystal.png")
    );
    const geometryP = new THREE.Geometry();
    const materialP = new THREE.PointsMaterial({
      color: 0xffffff,
      size: 0.05,
      transparent: true,
      opacity: 0.99,
      map: crystal,
      blending: THREE.AdditiveBlending
    });
    const points = new THREE.Points(geometryP, materialP);

    return {
      scene,
      rot,
      radian,
      renderer,
      camera,
      light,
      light2,
      geometryC,
      materialC,
      loader,
      cube,
      geometryG,
      map1,
      ground,
      i,
      simplexNoise,
      crystal,
      geometryP,
      materialP,
      points
    };
  },
  mounted() {
    const $canvas = document.getElementById("canvas");
    this.renderer = new THREE.WebGLRenderer({
      antialias: true,
      canvas: $canvas
    });
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setClearColor(0xffffff);

    this.rot = { value: 0 };
    this.light2.position.set(10, 10, 10);
    this.cube.rotation.y = 3.14159;
    this.geometryG.computeVertexNormals();
    this.geometryG.computeFaceNormals();
    for (this.i = 0; this.i < this.geometryG.vertices.length; this.i++) {
      var vertex = this.geometryG.vertices[this.i];
      vertex.z = this.simplexNoise.noise2D(vertex.x / 1, vertex.y / 1) / 14;
    }
    this.ground.rotation.x = Math.PI / -2;
    this.ground.position.y = -2;
    this.ground.castShadow = true;
    this.ground.receiveShadow = true;
    for (var j = 0; j < 5000; j++) {
      var x = Math.random() * 10 - 5;
      var y = Math.random() * 10 - 5;
      var z = Math.random() * 10 - 5;
      this.geometryP.vertices.push(new THREE.Vector3(x, y, z));
    }
    this.scene.add(this.camera);
    this.scene.add(this.light);
    this.scene.add(this.light2);
    this.scene.add(this.cube);
    this.scene.add(this.ground);
    this.scene.add(this.points);

    this.onResize();
    window.addEventListener("resize", this.onResize);

    this.animate();
  },
  methods: {
    animate() {
      var time = Date.now() * 0.00005;
      this.points.rotation.x = time;
      this.radian = (this.rot.value * Math.PI) / 180;
      this.camera.position.x = 5 * Math.sin(this.radian);
      this.camera.position.z = 5 * Math.cos(this.radian);
      var lookAt_x = Math.sin(time * 10) * 0.1;
      var lookAt_y = Math.cos(time * 10) * 0.1 - 1;
      this.camera.lookAt(new THREE.Vector3(lookAt_x, lookAt_y, 0));
      this.points.rotation.z = Math.sin(time * 1) * 0.1;
      this.renderer.render(this.scene, this.camera);
      requestAnimationFrame(this.animate);
    },
    onResize() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      this.renderer.setPixelRatio(window.devicePixelRatio);
      this.renderer.setSize(width, height);
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();
    },
    window:onload = function() {
      const spinner = document.getElementById("loading");
      const spinner2 = document.querySelector(".spinner");
      spinner.classList.add("loaded");
      TweenMax.to(spinner2.style, 3, {
        display: "none",
        delay: 6
      });
    },
    ground1: function() {
      TweenMax.to(this.ground.material.color, 3, {
        r: 1,
        g: 1,
        b: 1,
        ease: "power2.out"
      });
      document.getElementById("home_click").style.color = "#ffd700";
      document.getElementById("about_click").style.color = "#000000";
      document.getElementById("contact_click").style.color = "#000000";
    },
    ground2: function() {
      TweenMax.to(this.ground.material.color, 3, {
        r: 0.7372,
        g: 0.4627,
        b: 0.2352,
        ease: "power2.out"
      });
      document.getElementById("home_click").style.color = "#000000";
      document.getElementById("about_click").style.color = "#ffd700";
      document.getElementById("contact_click").style.color = "#000000";
    },
    ground3: function() {
      TweenMax.to(this.ground.material.color, 3, {
        r: 0.6,
        g: 0.9,
        b: 0.3,
        ease: "power2.out"
      });
      document.getElementById("home_click").style.color = "#000000";
      document.getElementById("about_click").style.color = "#000000";
      document.getElementById("contact_click").style.color = "#ffd700";
    }
  }
};
</script>

<style>
html,
body {
  height: 100%;
  overflow: hidden;
}

body {
  margin: 0;
  padding: 0;
  background: #fff;
}

h1 {
  margin:0;
  padding:0;
  border:0;
  outline:0;
  font-size:100%;
  vertical-align:baseline;
  background:transparent;
}

#loading {
  display: flex;
  align-items: center;
  width: 100vw;
  height: 100vh;
  transition: all 1s;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}

.loaded {
  opacity: 0;
  visibility: hidden;
}

.spinner,
.spinner:before,
.spinner:after {
  background: #000000;
  -webkit-animation: load1 1s infinite ease-in-out;
  animation: load1 1s infinite ease-in-out;
  width: 1em;
  height: 4em;
}
.spinner {
  color: #000000;
  text-indent: -9999em;
  margin: 88px auto;
  position: relative;
  font-size: 11px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.spinner:before,
.spinner:after {
  position: absolute;
  top: 0;
  content: "";
}
.spinner:before {
  left: -1.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.spinner:after {
  left: 1.5em;
}
@-webkit-keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}
@keyframes load1 {
  0%,
  80%,
  100% {
    box-shadow: 0 0;
    height: 4em;
  }
  40% {
    box-shadow: 0 -2em;
    height: 5em;
  }
}

#canvas {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.logo {
  display: flex;
  position: relative;
}

.logo-mark {
  position: absolute;
  margin-left: 16px;
  margin-top: 14px;
}

.logo-mark img {
  width: 30px;
  height: 30px;
}

.logo-text {
  position: absolute;
  margin-left: 56px;
  margin-top: 10px;
}

.logo-text img {
  width: 152px;
  height: 40px;
}

.btn-box {
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 44px;
  top: 44px;
}

.btn-text {
  text-align: right;
  font-size: 36px;
  font-family: "Saira Semi Condensed", serif;
  font-weight: 600;
  cursor: pointer;
}

.btn-text:nth-child(1) {
  margin: 0 0 0 auto;
  width: 100px;
}

.btn-text:nth-child(2) {
  margin: 0 0 0 auto;
  width: 102px;
}

.btn-text:nth-child(3) {
  margin: 0 0 0 auto;
  width: 128px;
}

#home_click {
  color: #ffd700;
}

@media screen and (max-width: 414px) {
  .btn-box {
    right: 16px;
    top: 20px;
  }

  .btn-text {
    font-size: 32px;
  }
}

@media screen and (max-width: 320px) {
  .btn-box {
    right: 10px;
    top: 2px;
  }

  .btn-text {
    font-size: 25px;
  }
}

@media (orientation: landscape) and (max-width: 812px) {
  .btn-box {
    right: 14px;
    top: 8px;
  }

  .btn-text {
    font-size: 32px;
  }
}

@media (orientation: landscape) and (max-width: 667px) {
  .btn-box {
    right: 10px;
    top: 2px;
  }

  .btn-text {
    font-size: 25px;
  }
}
</style>